"use client";

import React from "react";
import { FormProvider, useWvcForm } from "@/integrations/forms/FormProvider";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Form, FormField, FormItem, FormLabel, FormControl, FormMessage, FormDescription } from "@/components/ui/form";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Loader, CircleCheck, MessageSquare, Calculator, Clock } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const serviceOptions = ["Արբանյակային Պատկերների Ստացում", "Վերգետնյա կայաններ", "Ֆոտոգրամետրիական աշխատանքներ", "Գեոդեզիական աշխատանքներ", "Ռելիեֆի և տեղանքի թվային մոդելների ստեղծում", "Այլ խորհրդատվություն"];
function QuoteForm() {
  const {
    isSubmitting,
    isSubmitted,
    submitError,
    successMessage,
    handleSubmit,
    resetForm,
    control
  } = useWvcForm();
  if (isSubmitted && !submitError) {
    return <div className="flex flex-col items-center justify-center py-12 text-center space-y-4 animate-in fade-in zoom-in duration-500">
        <div className="size-16 bg-primary/10 rounded-lg flex items-center justify-center mb-4">
          <CircleCheck className="size-8 text-primary" />
        </div>
        <h3 className="text-2xl font-default font-semibold text-foreground">
          Հարցումն ընդունված է
        </h3>
        <p className="text-muted-foreground max-w-sm">
          {successMessage}
        </p>
        <Button onClick={resetForm} variant="outline" className="mt-6">
          Ուղարկել նոր հարցում
        </Button>
      </div>;
  }
  return <Form onSubmit={handleSubmit} className="space-y-5">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
        <FormField control={control} name="name" rules={{
        required: "Անունը պարտադիր է",
        minLength: {
          value: 2,
          message: "Նվազագույնը 2 նիշ"
        }
      }} render={({
        field
      }) => <FormItem>
              <FormLabel>Անուն Ազգանուն</FormLabel>
              <FormControl>
                <Input placeholder="Օրինակ՝ Արամ Արամյան" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>} />

        <FormField control={control} name="phone" rules={{
        required: "Հեռախոսահամարը պարտադիր է",
        pattern: {
          value: /^[0-9+\-\s()]*$/,
          message: "Անվավեր ձևաչափ"
        }
      }} render={({
        field
      }) => <FormItem>
              <FormLabel>Հեռախոսահամար</FormLabel>
              <FormControl>
                <Input type="tel" placeholder="+374 00 000000" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>} />
      </div>

      <FormField control={control} name="email" rules={{
      required: "Էլ. հասցեն պարտադիր է",
      pattern: {
        value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
        message: "Անվավեր էլ. հասցե"
      }
    }} render={({
      field
    }) => <FormItem>
            <FormLabel>Էլեկտրոնային հասցե</FormLabel>
            <FormControl>
              <Input type="email" placeholder="example@domain.am" {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>} />

      <FormField control={control} name="service" rules={{
      required: "Խնդրում ենք ընտրել ծառայությունը"
    }} render={({
      field
    }) => <FormItem>
            <FormLabel>Հետաքրքրող ծառայություն</FormLabel>
            <Select onValueChange={field.onChange} defaultValue={field.value}>
              <FormControl>
                <SelectTrigger>
                  <SelectValue placeholder="Ընտրեք ծառայության տեսակը" />
                </SelectTrigger>
              </FormControl>
              <SelectContent>
                {serviceOptions.map((option, i) => <SelectItem key={i} value={option} data-index={i}>
                    {option}
                  </SelectItem>)}
              </SelectContent>
            </Select>
            <FormMessage />
          </FormItem>} />

      <FormField control={control} name="message" rules={{
      required: "Նախագծի նկարագրությունը պարտադիր է",
      minLength: {
        value: 10,
        message: "Նվազագույնը 10 նիշ"
      }
    }} render={({
      field
    }) => <FormItem>
            <FormLabel>Նախագծի մանրամասներ</FormLabel>
            <FormControl>
              <Textarea placeholder="Նկարագրեք ձեր նախագիծը, պահանջները և ակնկալիքները..." className="min-h-[120px] resize-y" {...field} />
            </FormControl>
            <FormDescription>
              Որքան մանրամասն նկարագրեք, այնքան ավելի ճշգրիտ գնառաջարկ կկարողանանք տրամադրել:
            </FormDescription>
            <FormMessage />
          </FormItem>} />

      {submitError && <div className="p-4 bg-destructive/10 border border-destructive/20 rounded-md text-destructive text-sm">
          {submitError}
        </div>}

      <Button type="submit" disabled={isSubmitting} className="w-full h-12 text-base">
        {isSubmitting ? <>
            <Loader className="mr-2 size-5 animate-spin" />
            Ուղարկվում է...
          </> : "Ստանալ գնառաջարկ"}
      </Button>
    </Form>;
}
export default function ContactSection() {
  const {
    ref: textRef,
    isVisible: isTextVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: formRef,
    isVisible: isFormVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return;
}